import { render, staticRenderFns } from "./QcqQualityPage.vue?vue&type=template&id=9b186608&scoped=true&lang=pug&"
import script from "./QcqQualityPage.vue?vue&type=script&lang=ts&"
export * from "./QcqQualityPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b186608",
  null
  
)

export default component.exports